import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

import { ShareRestrictAndCopyButtonPlaceholder } from './shareAndRestrictButton/ShareRestrictAndCopyButtonPlaceholder';

export const ShareAndRestrictButtonSSRLoader = LoadablePaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareRestrictAndCopyButton" */ './shareAndRestrictButton/ShareRestrictAndCopyCoordinator'
			)
		).ShareRestrictAndCopyCoordinator,
});

export const ShareAndRestrictButtonLoader = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareRestrictAndCopyButton" */ './shareAndRestrictButton/ShareRestrictAndCopyCoordinator'
			)
		).ShareRestrictAndCopyCoordinator,
	loading: ShareRestrictAndCopyButtonPlaceholder,
});
